<script>
import { fandomBasicMixin } from 'src/modules/fandom_mixins_module.js';

export default {
  mixins: [fandomBasicMixin],
  data() {
    return {
    }
  },
  mounted() {
    Vue.nextTick(() => {
      setTimeout(() => {
        this.openModal()
      }, 3000);
    });
  },
  methods: {
    openModal() {
      $("#modal-newsletter-recipes").modal("show");
    },
  },
  computed: {

  }
};
</script>

<template>
  <div id="modal-newsletter-recipes" class="modal fade" tabindex="-1" role="dialog" modal-newsletter-recipes-component>
    <div class="modal-dialog modal-dialog-centered modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header border-0">
          <h5 class="modal-title">{{ft("globals.privacy")}}</h5>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" v-html="globalState.pageModel.layout.content.privacy"></div>
        <div class="modal-footer">
          <button type="button" class="btn px-3 btn-secondary" data-dismiss="modal">{{ft("globals.close")}}</button>
        </div>
      </div>
    </div>
  </div>
</template>

<style lang="scss">
[modal-newsletter-recipes-component] {
  .modal {
    &-dialog {
      overflow: hidden;
      transition: transform 0.3s ease-out, max-width 0.25s, height 0.25s !important;
    }

    &-body {

      & > .container {
        overflow-y: auto;
      }

      .close-icon {
        position: absolute;
        top: 0;
        right: 0;
      }
    }
  }

  .modal-elements{
    text-align: center;

    .image {
      max-width: 16rem;
    }
  }

}
</style>